export default function PlayFullscreenActiveIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M285.27,153.22c-6.63,0-12,5.37-12,12s5.37,12,12,12h20.75l-46.18,46.18c-4.69,4.69-4.69,12.28,0,16.97,2.34,2.34,5.41,3.51,8.49,3.51s6.14-1.17,8.49-3.51l45.77-45.77v19.78c0,6.63,5.37,12,12,12s12-5.37,12-12v-61.17h-61.3Z"/>
      <path d="M223.2,259.62l-45.77,45.77v-19.78c0-6.63-5.37-12-12-12s-12,5.37-12,12v61.17h61.3c6.63,0,12-5.37,12-12s-5.37-12-12-12h-20.75l46.18-46.18c4.69-4.69,4.69-12.28,0-16.97s-12.29-4.69-16.97,0Z"/>
      <polygon points="177.5,177.5 229,177.5 229,153.5 153.5,153.5 153.5,229 177.5,229" />
      <polygon points="322.5 322.5 271 322.5 271 346.5 346.5 346.5 346.5 271 322.5 271 322.5 322.5" />
      <circle cx="250" cy="416.5" r="27.5" />
    </svg>
  );
}
